import React from "react";

import { faLink } from "@awesome.me/kit-4c83d50d0d/icons/classic/regular";

import { useCopyMeetingLink } from "~/meetings/hooks/useCopyMeetingLink";
import { Menu } from "~/ui/menu";

import type { useCopyMeetingLink_note$key } from "~/__generated__/useCopyMeetingLink_note.graphql";

export default function CopyLinkMenuItem({ note: noteKey }: { note: useCopyMeetingLink_note$key }) {
	const copyLink = useCopyMeetingLink(noteKey);

	return (
		<Menu.Item icon={faLink} onSelect={copyLink}>
			Copy link
		</Menu.Item>
	);
}
